<!--
create by melody on 2018/12/9
description:lap切换语言
-->
<template>
    <!-- <el-button type="text"> -->
    <div class="changeStyle">
        <span :class="systemLang == 'zh_CN'? 'choose' : 'notChoose'"  @click="clickChangeLanguage('zh_CN')">中文</span>/
        <span :class="systemLang == 'en_US'? 'choose' : 'notChoose'" @click="clickChangeLanguage('en_US')">English</span>
    </div>
    <!-- </el-button> -->
    <!-- <el-button type="text" @click="clickChangeLanguage()">{{systemLang == 'zh' ? '中文' : 'English'}}</el-button> -->
</template>
<script>
export default {
    data() {
        return {
            systemLang: sessionStorage.getItem('defaultLang') == "en_US" ? "en_US" : 'zh_CN',
        }
    },
    methods: {
        clickChangeLanguage(lang) {
            if(lang == 'en_US') {
                this.systemLang = 'en_US'
                sessionStorage.setItem('defaultLang', 'en_US')
            } else {
                this.systemLang = 'zh_CN'
                sessionStorage.setItem('defaultLang', 'zh_CN')
            }
            window.location.reload()
            //this.$i18n.locale = sessionStorage.getItem('defaultLang')//修改语言，不用刷新页面 不树新页面data里面的国际化会不生效
        },
    },
}
</script>
<style scoped>
.changeStyle {
    line-height: 40px;
    height: 40px;
    font-size: 14px;
    cursor: pointer;
}
.choose {
    color: #409EFF
}
.notChoose {
    color: #97999B
 }
</style>



// WEBPACK FOOTER //
// src/components/common/LapChangeLang.vue